import { render } from "./alimentacionSinSoporte.vue?vue&type=template&id=6a5359d2"
import script from "./alimentacionSinSoporte.vue?vue&type=script&lang=js"
export * from "./alimentacionSinSoporte.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__